import React from "react";
import VerifyPanCard from "../../organisms/InitialPagesComponents/AuthBridge/VerifyPanCard/VerifyPanCard";

const VerifyPanCardPage = () => {
  return <VerifyPanCard />;
};

export default VerifyPanCardPage;
